import { useLocation, useNavigate } from "react-router-dom";
import DataTableWrapper from "../../../Utility/DataTableWrapper/DataTableWrapper";
import { useContext, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { FormUtility } from "../../../Utility/FormUtility";
import { rolesCodes } from "../../../../constants/Roles";
import Select from "../../../Form/Select";
import Upload from "../../../Form/Upload";
import ToastContext from "../../../../contexts/toast";
import FiltriAvanzati from "../../../Utility/FiltriAvanzati/FiltriAvanzati";
import Modal from "../../../Utility/Modal/Modal";
import { BandoService } from "../../../../services/BandoService";
import { IndirizzoStudioService } from "../../../../services/IndirizzoStudioService";
import { ComuneService } from "../../../../services/ComuneService";

export default function GestioneIndirizziStudio() {
  console.log("inside gestione indirizzi di studio");

  const [dtOptions, setDtOptions] = useState({});
  const navigate = useNavigate();

  const [avviso, setAvviso] = useState(null);
  const [avvisi, setAvvisi] = useState([]);

  const [provincia, setProvincia] = useState(null);
  const [province, setProvince] = useState([]);

  const [comune, setComune] = useState(null);
  const [comuni, setComuni] = useState([]);

  const [ordine, setOrdine] = useState(null);
  const ordini = [
    { key: "I", value: "Secondaria I° Grado" },
    { key: "S", value: "Secondaria II° Grado" },
  ];

  const [gestione, setGestione] = useState(null);
  const gestioni = [{ value: "Statale", key: "STATALE" }, { value: "Paritaria", key: "PARITARIA" }];

  const [currMapFilters, setCurrMapFilters] = useState(new Map());
  const [nextMapFilters, setNextMapFilters] = useState(null);
  const [advancedFiltersMap, setAdvancedFiltersMap] = useState(null);
  const [nextAdvancedFiltersMap, setNextAdvancedFiltersMap] = useState(null);

  const [firstLoad, setFirstLoad] = useState(false);

  const location = useLocation();

  const [isModalOpen, setModalOpen] = useState(false);

  const [disabledConfirmBtn, setDisabledConfirmBtn] = useState(true);

  const [title, setTitle] = useState(null);
  const [actionLabel, setActionLabel] = useState("");
  const [content, setContent] = useState(null);
  const [reportData, setReportData] = useState(null);

  const toastContext = useContext(ToastContext);

  const roles = useSelector((state) => state.role);
  const utility = new FormUtility({ data: roles });

  const bandoService = new BandoService();
  const comuneService = new ComuneService();
  const indirizzoService = new IndirizzoStudioService();

  const [validazioneVisible, setValidazioneVisible] = useState(false);
  const [validazioneClass, setValidazioneClass] = useState(null);
  const [validazioneIcon, setValidazioneIcon] = useState(null);
  const [file, setFile] = useState(null);
  const [esitoImportazione, setEsitoImportazione] = useState(null);
  const [closeLabel, setCloseLabel] = useState("Annulla");
  const [spinnerVisible, setSpinnerVisible] = useState(false);
  const [disableCloseBtn, setDisableCloseBtn] = useState(false);
  const uploadRef = useRef(null);

  const dtRef = useRef();
  const rowRef = useRef(null);

  useEffect(() => {
    bandoService.getAll().then((resp) => {
      setAvvisi([...resp]);
    });

    comuneService.getAllProvinceByRegione("Toscana").then((resp) => {
      resp.sort((a, b) => (a.value.localeCompare(b.value)));
      setProvince(resp);

      const filtri = utility.getFiltriAvanzatiStorage(
        location,
        "_filtri_avanzati"
      );
      if (filtri?.Avviso) {
        onChangeFilter("Avviso", filtri.Avviso, new Map(nextMapFilters), new Map(nextAdvancedFiltersMap));
      }
    });
  }, []);

  useEffect(() => {
    if (comuni.length === 0 || firstLoad) {
      return;
    }

    const filtri = utility.getFiltriAvanzatiStorage(
      location,
      "_filtri_avanzati"
    );
    setOnLoadFiltriAvanzatiFromStorage(filtri);
    setNextMapFilters(filtri ? new Map(Object.entries(filtri)) : new Map());
    setCurrMapFilters(filtri ? new Map(Object.entries(filtri)) : new Map());

    setFirstLoad(true);
  }, [comuni, firstLoad]);

  const setOnLoadFiltriAvanzatiFromStorage = (filtri) => {
    const filtriAvanzati = advancedFiltersMap ?? new Map();
    const proxMappaFiltri = new Map(nextMapFilters);
    const proxMappaFiltriAvanzati = new Map(nextAdvancedFiltersMap);

    for (const key in filtri) {
      const value = filtri[key];

      let filterValue = value;
      let filtroAvanzato = value;
      switch (key) {
        case "Comune":
          filterValue = comuni.find((el) => el.denominazione === value)?.codice;
          break;
        case "Ordine":
          filterValue = ordini.find((el) => el.value === value)?.key;
          break;
        case "Gestione":
          filterValue = gestioni.find((el) => el.value === value)?.key;
          break;
        default:
          break;
      }

      onChangeFilter(key, filterValue, proxMappaFiltri, proxMappaFiltriAvanzati, false);
      filtriAvanzati.set(key, filtroAvanzato);
    }

    setNextAdvancedFiltersMap(new Map(filtriAvanzati));
    setAdvancedFiltersMap(new Map(filtriAvanzati));
  };

  const handleModalAction = async () => {
    if (!!rowRef.current) {
      indirizzoService
        .delete(
          rowRef.current.idIndirizzo ?? -1,
          rowRef.current.idPlesso,
          rowRef.current.idIstituto
        )
        .then(() => {
          rowRef.current = null;
          dtRef.current.rerenderDatatable();
          toastContext.success(
            "Indirizzo di studio eliminato con successo!",
            6000
          );
          setModalOpen(false);
        })
        .catch((error) => {
          rowRef.current = null;
          toastContext.error(utility.getErrorMsg(error), 12000);
          setModalOpen(false);
        });

      return;
    }

    setDisableCloseBtn(true);
    setDisabledConfirmBtn(true);
    setSpinnerVisible(true);
    uploadRef.current.reset();
    uploadRef.current.disableButtons();

    try {
      const esito = await indirizzoService.importa(file, avviso);
      uploadRef.current.enableButtons();
      setDisableCloseBtn(false);
      setDisabledConfirmBtn(false);
      setSpinnerVisible(false);

      if (esito.importazioneFatta) {
        toastContext.success("Importazione avvenuta con successo", 4000);
        setEsitoImportazione(esito);
        setValidazioneVisible(false);
        setDisabledConfirmBtn(true);
        setCloseLabel("Chiudi");
        dtRef.current.rerenderDatatable();
      } else {
        toastContext.warning("Importazione non riuscita", 4000);
      }
    } catch (error) {
      console.error("Errore durante l'importazione:", error);
      toastContext.error(
        "Si è verificato un errore durante l'importazione.",
        4000
      );
      uploadRef.current.enableButtons();
      setDisableCloseBtn(false);
      setDisabledConfirmBtn(false);
      setSpinnerVisible(false);
    }
  };

  useEffect(() => {
    if (avviso) {
      comuneService
        .getAllByBandoAndTipologiaAndDenominazioneRegioneAndProvincia(
          avviso,
          "Comune",
          "Toscana",
          provincia
        )
        .then((resp) => {
          resp.sort((a, b) => (a.denominazione.localeCompare(b.denominazione)));
          setComuni([...resp]);
        });
    }
  }, [avviso]);

  const setFiltriAvanzatiInStorage = (mapFilters) => {
    const obj = Object.fromEntries(mapFilters);
    sessionStorage.setItem(
      `${location.pathname}_filtri_avanzati`,
      JSON.stringify(obj)
    );
  };

  const onChangeFilter = async (type, val, mappaFiltri, mappaFiltriAvanzati, updateNextMap = true, updateMap = false) => {
    let mapValue = val;
    let mapAvanzatoValue = val;

    switch (type) {
      case "Avviso":
        setAvviso(val);
        break;
      case "Provincia":
        setProvincia(val);
        const resp =
          await comuneService.getAllByBandoAndTipologiaAndDenominazioneRegioneAndProvincia(
            avviso,
            "Comune",
            "Toscana",
            val
          );
        if (!resp.find((c) => c.codice === comune)) {
          setComune(null);
          mappaFiltri.delete("Comune");
        }
        resp.sort((a, b) => (a.denominazione.localeCompare(b.denominazione)));
        setComuni([...resp]);
        break;
      case "Comune":
        mapValue = comuni.find((e) => e.codice === val)?.denominazione;
        setComune(val);
        break;
      case "Ordine":
        mapValue = ordini.find((e) => e.key === val)?.value;
        setOrdine(val);
        break;
      case "Gestione":
        mapValue = gestioni.find((e) => e.key === val)?.value;
        setGestione(val);
        break;
      default:
        break;
    }

    if (!mapValue) {
      mappaFiltri.delete(type);
      mappaFiltriAvanzati.delete(type);
    } else {
      mappaFiltri.set(type, mapValue);
      mappaFiltriAvanzati.set(type, mapAvanzatoValue);
    }

    if (updateNextMap) {
      setNextMapFilters(new Map(mappaFiltri));
      setNextAdvancedFiltersMap(new Map(mappaFiltriAvanzati));
    }

    if (!updateMap) {
      return;
    }

    setCurrMapFilters(new Map(mappaFiltri));
    setAdvancedFiltersMap(new Map(mappaFiltriAvanzati));
    setFiltriAvanzatiInStorage(new Map(mappaFiltri));
  };

  const modificaIndirizzo = (indirizzoId) => {
    navigate(`/gestione-indirizzo-studio/${indirizzoId}`);
  };

  const rimuoviIndirizzo = (row) => {
    setTitle("Elimina indirizzo di studio");
    setContent("Sei sicuro di voler rimuovere questo indirizzo di studio? Una volta rimosso, non potrai recuperarlo.");
    setActionLabel("Conferma");
    setModalOpen(true);
    setDisabledConfirmBtn(false);
    rowRef.current = row;
  };

  useEffect(() => {
    if (!firstLoad || !currMapFilters || !avviso) {
      return;
    }

    createDtOptions();
    loadData();
  }, [currMapFilters]);

  const createDtOptions = () => {
    const dtOpt = {
      columns: [
        {
          name: "Id",
          data: "id",
          visible: true,
          sortable: false,
          searchable: true,
        },
        {
          name: "Istituzione Scolastica",
          data: "codiceIstituto",
          visible: true,
          sortable: true,
          searchable: true,
          cell: (row, col) =>
            row.codiceIstituto + " - " + row.denominazioneIstituto,
        },
        {
          name: "Plesso",
          data: "codicePlesso",
          visible: true,
          sortable: true,
          searchable: true,
          cell: (row, col) =>
            row.codicePlesso + " - " + row.denominazionePlesso,
        },
        {
          name: "Ordine e Grado",
          data: "ordinePlesso",
          visible: true,
          sortable: true,
          searchable: true,
          cell: (row, col) =>
            row.ordinePlesso + " - " + row.ordinePlessoCompleto,
        },
        {
          name: "Gestione",
          data: "gestionePlesso",
          visible: true,
          sortable: true,
          searchable: true,
        },
        {
          name: "Comune Plesso",
          data: "codiceComunePlesso",
          visible: true,
          sortable: true,
          searchable: true,
          cell: (row, col) =>
            row.codiceComunePlesso + " - " + row.denominazioneComunePlesso,
        },
        {
          name: "Indirizzo di studio",
          data: "codiceIndirizzo",
          visible: true,
          sortable: true,
          searchable: true,
          cell: (row, col) =>
            row.codiceIndirizzo
              ? row.codiceIndirizzo + " - " + row.denominazioneIndirizzo
              : "",
        },
        {
          name: "Azioni",
          data: null,
          visible: true,
          sortable: false,
          searchable: false,
          center: true,
          cell: (row, col) => (
            <div
              className="rtds-inline-flex rtds-gap-1"
              role="group"
              aria-label="Azioni"
            >
              <button
                type="button"
                className="rtds-btn--secondary rtds-btn rtds-btn--s rtds-btn--icon-left rtds-group/button"
                onClick={() => modificaIndirizzo(row.id)}
                title={"Modifica indirizzo di studio"}
              >
                <svg
                  className="rtds-icon rtds-fill-current rtds-w-5 rtds-h-5 group-hover/button:-rtds-translate-x-1"
                  aria-hidden="true"
                  focusable="false"
                  role="img"
                >
                  <use
                    xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--pencil-square`}
                  />
                </svg>
                Modifica
              </button>{" "}
              <button
                type="button"
                className="rtds-btn--danger rtds-btn rtds-btn--s rtds-btn--icon-left rtds-group/button"
                onClick={() => rimuoviIndirizzo(row)}
                title={"Rimuovi indirizzo di studio"}
              >
                <svg
                  className="rtds-icon rtds-fill-current rtds-w-5 rtds-h-5 group-hover/button:-rtds-translate-x-1"
                  aria-hidden="true"
                  focusable="false"
                  role="img"
                >
                  <use
                    xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--minus-circle`}
                  />
                </svg>
                Rimuovi
              </button>
            </div>
          ),
        },
        { data: "denominazioneIstituto", searchable: true, omit: true },
        { data: "denominazionePlesso", searchable: true, omit: true },
        { data: "denominazioneIndirizzo", searchable: true, omit: true },
        { data: "denominazioneComunePlesso", searchable: true, omit: true },
      ],
      serverSide: true,
      ajax: indirizzoService.getAllDt,
      ajaxParams: {
        bandoId: avviso,
        provincia: provincia,
        comune: comune,
        ordine: ordine,
        gestione: gestione,
      },
      rows: [
        /*{ id: 1, title: 'test 123', year: '2024/25', fasi: ['prima fase', 'seconda fase'], rules: 'Regole relative comune del 23/24' }*/
      ],
      sorts: [],
      hideSearch: false,
      title: "Elenco indirizzi di studio",
    };
    setDtOptions(dtOpt);
  };

  const loadData = async () => {
    // let rows= [];
    // for (let i = 1;i<400;i++){
    //     rows.push({ id: i, title: 'test ' + i, year: '2024/25', fasi: ['prima fase', 'seconda fase'], rules: 'Regole relative comune del 23/24' });
    // }
    // setDtOptions((dtOptions)=> ({...dtOptions,rows}));
  };

  const goToGestioneIndirizzoStudio = () => {
    navigate("/gestione-indirizzo-studio/");
  };

  const onUploadOk = async () => {};

  const onValidationDone = async (data, file) => {
    setEsitoImportazione(null);
    if (data) {
      if (data.errori.length == 0) {
        setValidazioneClass("rtds-text-success-dark");
        setValidazioneIcon("icons.svg#solid--check");
        const mappedData = [
          { number: data.numeroOkStatale, message: "Statali" },
          { number: data.numeroOkParitaria, message: "Paritarie" },
          { number: data.numeroOkPrimoGrado, message: "Primo grado" },
          { number: data.numeroOkSecondoGrado, message: "Secondo grado" },
          {
            number: data.numeroOkPrimoGradoStatale,
            message: "Primo grado statale",
          },
          {
            number: data.numeroOkSecondoGradoStatale,
            message: "Secondo grado statale",
          },
          {
            number: data.numeroOkPrimoGradoParitaria,
            message: "Primo grado paritaria",
          },
          {
            number: data.numeroOkSecondoGradoParitaria,
            message: "Secondo grado paritaria",
          },
        ];
        setReportData(mappedData);
        setDisabledConfirmBtn(false);
        setFile(file);
      } else {
        setFile(null);
        setDisabledConfirmBtn(true);
        setValidazioneClass("rtds-text-error-dark");
        setValidazioneIcon("icons.svg#solid--x-mark");
        const mappedErrors = data.errori.flat().map((error) => {
          return {
            number: error.numeroRiga ? error.numeroRiga : "",
            message: error.messaggio,
          };
        });
        setReportData(mappedErrors);
      }
      setValidazioneVisible(true);
    } else {
      setFile(null);
      setValidazioneVisible(false);
      toastContext.warning("Nessun dato", 4000);
    }
  };

  const onCloseModal = async () => {
    setModalOpen(false);
    setDisabledConfirmBtn(true);
    setReportData([]);
    setValidazioneVisible(false);
    setValidazioneClass(null);
    setValidazioneIcon(null);
    setEsitoImportazione(null);
    rowRef.current = null;
  };

  const downloadTemplate = async () => {
    const response = await indirizzoService.downloadTemplate();
    utility.downloadFile(response.data, "template.xlsx");
    toastContext.success("Modello scaricato con successo", 4000);
  };

  const onSearch = async () => {
    setCurrMapFilters(new Map(nextMapFilters));
    setAdvancedFiltersMap(new Map(nextAdvancedFiltersMap));
    setFiltriAvanzatiInStorage(nextMapFilters);
  };

  const onFileChanged = async () => {
    setDisabledConfirmBtn(true);
    setValidazioneVisible(false);
  };

  const validExtensions = ["xlsx", "xls"];

  return (
    <>
      <div className="rtds-container rtds-py-6">
        <div className="rtds-grid rtds-gap-6 xl:rtds-gap-8">
          <div className="rtds-flex rtds-items-center rtds-justify-between">
            <h1 className="rtds-heading-2">Scuole e indirizzi di studio</h1>
          </div>
          <Select
            classDiv={"rtds-mt-0 lg:rtds-mt-0"}
            label={"Avviso"}
            id={"avviso"}
            classSelect={""}
            onChange={(event) => {
              onChangeFilter("Avviso", event.target.value ? event.target.value : null, new Map(nextMapFilters), new Map(nextAdvancedFiltersMap), true, true);
            }}
            baseOption={"Nessuna selezione"}
            bindKey={"id"}
            bindValue={"nome"}
            options={avvisi}
            value={avviso || ""}
          />

          {avviso && (
            <FiltriAvanzati
              hidden={avviso == null}
              mapFilters={currMapFilters}
              onRemoveFilter={(type) => onChangeFilter(type, null, new Map(nextMapFilters), new Map(nextAdvancedFiltersMap), true, true)}
              fieldsToAvoid={["Avviso"]}
            >
              <div className="rtds-grid rtds-gap-3">
                <div className="rtds-field-row">
                  <Select
                    classDiv={"rtds-mt-3 lg:rtds-mt-0"}
                    label={"Provincia"}
                    id={"provincia"}
                    classSelect={""}
                    onChange={(event) => 
                      onChangeFilter("Provincia", event.target.value ? event.target.value : null, new Map(nextMapFilters), new Map(nextAdvancedFiltersMap))
                    }
                    baseOption={"Nessuna selezione"}
                    options={province}
                    bindValue={"key"}
                    value={provincia || ""}
                  />
                  <Select
                    classDiv={"rtds-mt-3 lg:rtds-mt-0"}
                    label={"Comune"}
                    id={"comune"}
                    classSelect={""}
                    onChange={(event) => 
                      onChangeFilter("Comune", event.target.value ? event.target.value : null, new Map(nextMapFilters), new Map(nextAdvancedFiltersMap))
                    }
                    baseOption={"Nessuna selezione"}
                    options={comuni}
                    bindValue={"denominazione"}
                    bindKey={"codice"}
                    value={comune || ""}
                  />
                </div>

                <div className="rtds-field-row">
                  <Select
                    classDiv={"rtds-mt-3 lg:rtds-mt-0"}
                    label={"Ordine e grado"}
                    id={"grado"}
                    classSelect={""}
                    onChange={(event) => 
                      onChangeFilter("Ordine", event.target.value ? event.target.value : null, new Map(nextMapFilters), new Map(nextAdvancedFiltersMap))
                    }
                    baseOption={"Nessuna selezione"}
                    options={ordini}
                    bindValue={"value"}
                    bindKey={"key"}
                    value={ordine || ""}
                  />
                  <Select
                    classDiv={"rtds-mt-3 lg:rtds-mt-0"}
                    label={"Gestione"}
                    id={"gestione"}
                    classSelect={""}
                    onChange={(event) => 
                      onChangeFilter("Gestione", event.target.value ? event.target.value : null, new Map(nextMapFilters), new Map(nextAdvancedFiltersMap))
                    }
                    baseOption={"Nessuna selezione"}
                    options={gestioni}
                    bindValue={"value"}
                    bindKey={"key"}
                    value={gestione || ""}
                  />
                </div>
                <div className="rtds-form-actions rtds-flex rtds-justify-start">
                  <button
                    type="button"
                    className="rtds-btn rtds-btn--icon-right rtds-group/button rtds-btn--secondary"
                    onClick={() => {
                      onSearch();
                    }}
                  >
                    Cerca
                    <svg
                      className="rtds-icon rtds-fill-current rtds-w-5 rtds-h-5 group-hover/button:rtds-translate-x-1"
                      aria-hidden="true"
                      focusable="false"
                      role="img"
                    >
                      <use
                        xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#mini--chevron-right`}
                      />
                    </svg>
                  </button>
                </div>
              </div>
            </FiltriAvanzati>
          )}
        </div>
      </div>
      {avviso && (
        <DataTableWrapper
          ref={dtRef}
          dtOptions={dtOptions}
          headerButton={
            <>
              <div className="rtds-flex rtds-gap-4 rtds-items-center rtds-flex-wrap">
                <button
                  type="button"
                  className="rtds-btn--primary rtds-btn rtds-btn--icon-left rtds-group/button"
                  onClick={() => {
                    setModalOpen(true);
                    setTitle("Importazione da organico");
                    setActionLabel("Importa");
                  }}
                  
                >
                  <svg
                    className="rtds-icon rtds-fill-current rtds-w-6 rtds-h-6 group-hover/button:-rtds-translate-x-1"
                    aria-hidden="true"
                    focusable="false"
                    role="img"
                  >
                    <use
                      xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--plus-circle`}
                    />
                  </svg>
                  Importa da organico
                </button>
                <button
                  type="button"
                  className="rtds-btn--primary rtds-btn rtds-btn--icon-left rtds-group/button"
                  onClick={goToGestioneIndirizzoStudio}
                  hidden={utility.checkRoles([
                    rolesCodes.comune,
                    rolesCodes.comuneReferente,
                  ])}
                  disabled
                >
                  <svg
                    className="rtds-icon rtds-fill-current rtds-w-6 rtds-h-6 group-hover/button:-rtds-translate-x-1"
                    aria-hidden="true"
                    focusable="false"
                    role="img"
                  >
                    <use
                      xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--plus-circle`}
                    />
                  </svg>
                  Inserisci&nbsp;indirizzo di studio
                </button>
              </div>
            </>
          }
        />
      )}

      <Modal
        isOpen={isModalOpen}
        title={title}
        content={content}
        innerContent={``}
        onClose={() => onCloseModal()}
        onAction={handleModalAction}
        actionLabel={actionLabel}
        closeLabel={closeLabel}
        disabledConfirmBtn={disabledConfirmBtn}
        disableCloseBtn={disableCloseBtn}
        confirmLoading={spinnerVisible}
      >
        <div hidden={!!rowRef.current}>
          <article className="rtds-items-center rtds-mb-9 rtds-card rtds-card--information rtds-card--information-left-icon rtds-card--horizontal  rtds-card--horizontal-left rtds-group/card">
            <div className="rtds-card__icon ">
              <svg
                className="rtds-icon rtds-fill-current rtds-w-12 rtds-h-12"
                aria-hidden="true"
                focusable="false"
                role="img"
              >
                <use
                  xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#mini--information-circle`}
                />
              </svg>
            </div>

            <div className="rtds-card__content">
              <div className="rtds-card__description ">
                <div className="">
                  <a
                    className="rtds-action-link rtds-action-link--has-icon"
                    onClick={() => downloadTemplate()}
                    role="button"
                  >
                    Scarica&nbsp;il&nbsp;modello&nbsp;Excel&nbsp;
                    <svg
                      className="rtds-icon rtds-fill-current rtds-w-5 rtds-h-5 "
                      aria-hidden="true"
                      focusable="false"
                      role="img"
                    >
                      <use
                        xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--arrow-down-tray`}
                      />
                    </svg>
                    &nbsp;
                  </a>

                  <span className="rtds-body">
                    preimpostato per compilare i dati degli indirizzi di studio.
                  </span>
                </div>
              </div>
            </div>
          </article>

          {/*<button
            type="button"
            className="rtds-btn--primary rtds-btn rtds-btn--icon-left rtds-group/button rtds-mb-3"
          >
            <svg
              className="rtds-icon rtds-fill-current rtds-w-6 rtds-h-6 group-hover/button:-rtds-translate-x-1"
              aria-hidden="true"
              focusable="false"
              role="img"
            >
              <use
                xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--arrow-down-tray`}
              />
            </svg>
            Scarica template
          </button>*/}

          <Upload
            ref={uploadRef}
            id={"fileExcel"}
            onFileChanged={onFileChanged}
            onUploadOk={onUploadOk}
            onValidationDone={onValidationDone}
            validExtensions={validExtensions}
            caricaVisible={true}
            label={"Importa indirizzi di studio"}
          />

          {validazioneVisible && (
            <div className="rtds-p-3 rtds-border rtds-rounded rtds-border-gray-02">
              <h3 id="validazioneExcel" className="rtds-heading-6 rtds-mb-3">
                Validazione del file Excel
              </h3>
              <ul
                className="scrollable-list "
                aria-labelledby="validazioneExcel"
              >
                {reportData &&
                  reportData.map((item, index) => (
                    <li
                      key={index}
                      className="rtds-mb-2 rtds-aling-center rtds-flex "
                    >
                      <svg
                        className={`rtds-icon rtds-fill-current rtds-w-6 rtds-h-6 ${validazioneClass}`}
                        aria-hidden="true"
                        focusable="false"
                        role="img"
                      >
                        <use
                          xlinkHref={`${process.env.PUBLIC_URL}/${validazioneIcon}`}
                        />
                      </svg>
                      {validazioneClass.includes("error") && item.number && (
                        <>&nbsp;&nbsp;Alla riga:</>
                      )}
                      &nbsp;
                      <span className="rtds-content-info">{item.number}</span>
                      &nbsp;{item.message}
                    </li>
                  ))}
              </ul>
            </div>
          )}
          {esitoImportazione && (
            <div className="rtds-p-3 rtds-border rtds-rounded rtds-border-gray-02">
              <h3 id="validazioneExcel" className="rtds-heading-6 rtds-mb-3">
                Esito importazione
              </h3>
              <ul
                className="scrollable-list "
                aria-labelledby="validazioneExcel"
              >
                <li className="rtds-mb-2 rtds-aling-center rtds-flex ">
                  <svg
                    className={`rtds-icon rtds-fill-current rtds-w-6 rtds-h-6 rtds-text-success-dark`}
                    aria-hidden="true"
                    focusable="false"
                    role="img"
                  >
                    <use
                      xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--check`}
                    />
                  </svg>
                  &nbsp;
                  <span className="rtds-content-info">
                    {esitoImportazione.plessiPrimoGradoInseriti}
                  </span>
                  &nbsp;Plessi di primo grado inseriti
                </li>
                <li className="rtds-mb-2 rtds-aling-center rtds-flex ">
                  <svg
                    className={`rtds-icon rtds-fill-current rtds-w-6 rtds-h-6 rtds-text-success-dark`}
                    aria-hidden="true"
                    focusable="false"
                    role="img"
                  >
                    <use
                      xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--check`}
                    />
                  </svg>
                  &nbsp;
                  <span className="rtds-content-info">
                    {esitoImportazione.plessiPrimoGradoAggiornati}
                  </span>
                  &nbsp;Plessi di primo grado aggiornati
                </li>
                <li className="rtds-mb-2 rtds-aling-center rtds-flex ">
                  <svg
                    className={`rtds-icon rtds-fill-current rtds-w-6 rtds-h-6 rtds-text-success-dark`}
                    aria-hidden="true"
                    focusable="false"
                    role="img"
                  >
                    <use
                      xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--check`}
                    />
                  </svg>
                  &nbsp;
                  <span className="rtds-content-info">
                    {esitoImportazione.plessiSecondoGradoInseriti}
                  </span>
                  &nbsp;Plessi di secondo grado inseriti
                </li>
                <li className="rtds-mb-2 rtds-aling-center rtds-flex ">
                  <svg
                    className={`rtds-icon rtds-fill-current rtds-w-6 rtds-h-6 rtds-text-success-dark`}
                    aria-hidden="true"
                    focusable="false"
                    role="img"
                  >
                    <use
                      xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--check`}
                    />
                  </svg>
                  &nbsp;
                  <span className="rtds-content-info">
                    {esitoImportazione.plessiSecondoGradoAggiornati}
                  </span>
                  &nbsp;Plessi di secondo grado aggiornati
                </li>
                <li className="rtds-mb-2 rtds-aling-center rtds-flex ">
                  <svg
                    className={`rtds-icon rtds-fill-current rtds-w-6 rtds-h-6 rtds-text-success-dark`}
                    aria-hidden="true"
                    focusable="false"
                    role="img"
                  >
                    <use
                      xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--check`}
                    />
                  </svg>
                  &nbsp;
                  <span className="rtds-content-info">
                    {esitoImportazione.indirizziDiStudioInseriti}
                  </span>
                  &nbsp;Indirizzi di studio inseriti
                </li>
                <li className="rtds-mb-2 rtds-aling-center rtds-flex ">
                  <svg
                    className={`rtds-icon rtds-fill-current rtds-w-6 rtds-h-6 rtds-text-success-dark`}
                    aria-hidden="true"
                    focusable="false"
                    role="img"
                  >
                    <use
                      xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--check`}
                    />
                  </svg>
                  &nbsp;
                  <span className="rtds-content-info">
                    {esitoImportazione.indirizziDiStudioAggiornati}
                  </span>
                  &nbsp;Indirizzi di studio aggiornati
                </li>
              </ul>
            </div>
          )}
        </div>
      </Modal>
    </>
  );
}
